
import { createContext, useContext } from "react";
import { AuthContextType } from "@/types/auth";

const AuthContext = createContext<AuthContextType>({
  session: null,
  user: null,
  isLoading: true,
  signOut: async () => {},
  refreshSession: async () => {},
  secureLogin: async () => ({ error: new Error("Not implemented") }),
});

/**
 * Custom hook to access authentication context
 * @returns AuthContextType object containing session, user, loading state and auth functions
 */
export const useAuth = () => useContext(AuthContext);

export default AuthContext;
